import Header from '../common/Header'
const Login = () => {
    return (
      <div>
        <Header />
      </div>
    );
  };
  
  export default Login;